import clsx from 'clsx';

export default function LoadingSpinner({ size = 'md', className, text }) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  return (
    <div className={clsx('flex flex-col items-center justify-center', className)}>
      <svg
        className={clsx(
          'animate-spin text-blue-600 dark:text-blue-400',
          sizeClasses[size] || sizeClasses.md
        )}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      {text && (
        <p className="mt-3 text-sm text-slate-600 dark:text-slate-400">{text}</p>
      )}
    </div>
  );
}

// Full page loading spinner with centered content
LoadingSpinner.Page = function PageSpinner({ text = 'Loading...' }) {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <LoadingSpinner size="lg" text={text} />
    </div>
  );
};
